<div class="sign-msg-confirmation sign-msg-confirmation--visible">
    <div class="page-head">
        <app-back (onBack)="back()"></app-back>
        <h1 class="title title--size-l text--center">Sign message</h1>
    </div>
    <div class="page-content page-row" *ngIf="!loading">
        <div class="data-row">
            <p class="text text--color-secondary text--size-s">
                Wallet address
            </p>
            <p class="text text--bold address">
                {{ walletAddress }}
            </p>
        </div>
        <div class="data-row">
            <p class="text text--color-secondary text--size-s">Message</p>
            <p class="text text--bold msg-to-sign" [innerHTML]="msgToSign"></p>
        </div>
        <div class="actions">
            <button class="btn" (click)="denySign()">
                {{ "COMMON.REJECT" | translate }}
            </button>
            <button class="btn" (click)="confirmSign()">
                {{ "COMMON.CONFIRM" | translate }}
            </button>
        </div>
    </div>
    <div class="page-content page-row" class="loading" *ngIf="loading">
        <div>
            <div class="wrapper--center">
                <app-processing class="icon__processing"></app-processing>
            </div>
            <p
                style="margin-top: 16px"
                class="text text--size-l text--extra-bold text--center loading-text"
            >
                ...{{ "COMMON.LOADING" | translate }}...
            </p>
        </div>
    </div>
</div>
<app-alert
    *ngIf="!!failDescription"
    (onClose)="failDescription = null"
    (onAction)="failDescription = null"
    alert-title="Signing message failed"
    [alert-description]="failDescription"
    alert-action="COMMON.INDEX-DB-ALERT.ACTION"
></app-alert>
